import { observable } from 'mobx';
import type { Moment } from 'moment';
import moment from 'moment';
import Calendar from './calendar';

export type OpenMeetingBookingResponseArgs = {
  id: number;
  key: string;
  open_meeting_id: number;
  start_time: string;
  end_time: string;
  participants: {
    name?: string;
    connected_calendar_id: string;
    email: string;
    provider: string | null;
    calendar_id: string | null;
  }[];
};

export type OpenMeetingBookingArgs = {
  id: number;
  key: string;
  openMeetingId: number;
  startTime: Moment;
  endTime: Moment;
  participants: Calendar[];
};

export const convertOpenMeetingBookingResponseToArgs = (response: OpenMeetingBookingResponseArgs) => {
  const participants =
    response.participants?.map(
      p =>
        new Calendar({
          id: p.calendar_id || '',
          auth_data_id: p.connected_calendar_id,
          name: p.name || p.calendar_id || '',
          email: p.email,
          provider: p.provider
        })
    ) || [];
  const args: OpenMeetingBookingArgs = {
    id: response.id,
    key: response.key,
    openMeetingId: response.open_meeting_id,
    startTime: moment(response.start_time),
    endTime: moment(response.end_time),
    participants
  };
  return args;
};

export default class OpenMeetingBooking {
  @observable id: number;
  @observable key: string;
  @observable openMeetingId: number;
  @observable startTime: Moment;
  @observable endTime: Moment;
  @observable participants: Calendar[];

  constructor(args: OpenMeetingBookingArgs) {
    this.id = args.id;
    this.key = args.key;
    this.openMeetingId = args.openMeetingId;
    this.startTime = args.startTime;
    this.endTime = args.endTime;
    this.participants = args.participants;
  }
}
